"use client";

import Image from "next/image";
import React from "react";
import { Breadcrumb } from "../BreadCrumb";

interface PageHeroBannerWithBgProps {
  title: string;
  breadcrumbItems: {
    url: string;
    name: string;
  }[];
  image?: string;
  imageAlt?: string;
  pageName?: string;
}

export const PageHeroBannerWithBg = ({
  pageName,
  title,
  breadcrumbItems,
  image,
  imageAlt,
}: PageHeroBannerWithBgProps) => {
  return (
    <div className="w-full h-full relative min-h-[500px]">
      <Image
        src={
          image ||
          "/assets/images/flying-private-charter-jet-image-from-exterior-view-from-side-view-564753191.png"
        }
        alt={imageAlt || "Page Hero Banner"}
        fill
        className="object-cover object-center "
      />
      <div className="absolute inset-0 bg-black/70" />
      <div className="absolute inset-0 flex flex-col items-center justify-center pt-20">
        {pageName && (
          <span className="text-xs font-medium text-black bg-white px-4 py-2 rounded-full uppercase mb-4 max-w-[90%] md:max-w-1/2 text-center">
            {pageName}
          </span>
        )}
        <h1 className="text-5xl font-bold text-white mb-4 max-w-[90%] md:max-w-[40%] text-center capitalize">
          {title}
        </h1>
        <div>
          <Breadcrumb breadcrumbItems={breadcrumbItems} />
        </div>
      </div>
    </div>
  );
};
